function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemWo = function SvgLivemapSearchresultItemWo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Work Orders",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3299.873-4160.111h-13.448v-8.062h-1.125v-3.609h15.7v3.609h-1.126v8.061zm-12.771-8.062v7.384h12.098v-7.384zm-1.126-2.932v2.255h14.346v-2.255zm9.765 6.595h-4.808v-2.141h4.808v2.141zm4.589-8.61h-13.9v-.676h13.9v.675zm-1.008-1.833h-11.805v-.676h11.805v.676z",
    "data-name": "Path 11611",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-3282.299 4178.629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4459",
    style: {
      fill: "none"
    }
  }));
};
export default SvgLivemapSearchresultItemWo;